import { STATUS } from 'literals';

import * as types from 'types';

export const description = 'Ikigaibot';
export const name = 'Ikigaibot';
export const topic: types.Topic = {
  cached: false,
  data: [],
  message: '',
  status: STATUS.IDLE,
  updatedAt: 0,
};

export const coaches = [
  //   {
  //     name: 'MentorMirror',
  //     avatar: 'BigBroGrammer',
  //     office: 'BigBroGrammer_Office',
  //     primary: '#358d92',
  //     default: '#4dadb3',
  //     chatbotId: 'sQDZt05VVkMrhEG9CNMMJ',
  //     voiceId: 'ErXwobaYiN019PkySvjV',
  //     voiceSettings: {
  //       stability: 0.19,
  //       similarity_boost: 0.69,
  //     },
  //     description:
  //       'Explore what you bring to a mentoring relationship, plan for trust-building through dialogue.',
  //     prompt: `
  // My name is {{name}}. MentorMirror Mission:
  // Step 1: Welcome the mentor and explore the mentor's {{My Interests}} (e.g., "I'm going to help you build trust by modeling vulnerability in your mentoring relationship, {{name}}. What activities do you do for fun? What subjects did you enjoy most in high school?").
  // Step 2: Elicit and validate the mentor's {{My Skills}} (e.g., "What talents or strengths do you want to share as a mentor?").
  // Step 3: Inquire about and affirm the mentor's {{My Values}} (e.g., "What values or principles do you want to share?").
  // Step 4: Investigate and validate the mentor's {{My Worth}} (e.g., "How can you describe the core skills of your profession? What do you do for others?").
  // Step 5: Summarize and affirm what the mentor wants to share, affirming their disclosures and openness.
  // Step 6: Suggest opportunities to invite a high school-aged mentee into the mentor's interests, skills, values, and worth, if their mentee is interested.
  // Step 7: Recap the conversation with all the necessary variables for the output template.
  // Now, begin with Step 1 and pause for the mentor's response before proceeding to the next step.`,
  //   },
  {
    name: 'LearnerLens',
    avatar: 'AuntiePrenneur',
    office: 'AuntiePrenneur_Office',
    primary: '#eb6550',
    default: '#f5806d',
    voiceId: 'rla6jciKrNUTaXX8UA5W',
    voiceSettings: {
      stability: 0.42,
      similarity_boost: 0.59,
    },
    description:
      'Share your story to help a mentor know you better, build trust, and understand yourself more clearly.',
    // The interview agenda now lives server-side in the native agent's
    // system_prompt (Agents table, ops base appy5x5vC5HjN3Ukq, row
    // ikigai-v1) where it can be tuned without a deploy. This hidden
    // kickoff message only introduces the user and starts the interview.
    // The reducer substitutes {{name}}; the transcript formatter skips it.
    prompt: `My name is {{name}}. Please begin the interview.`,
  },
];

export const initialMessages = new Array(coaches.length);

// eslint-disable-next-line unicorn/prevent-abbreviations
for (let i = 0; i < coaches.length; i++) {
  initialMessages[i] = new Array<types.MessageData>();
}

export const initialQuestions = new Array(coaches.length);

export const functionDefinitions = [{
  name: 'get_user',
  description: "Get summary of user's information",
  parameters: {
    type: 'object',
    properties: {
      interests: {
        type: 'array',
        items: {
          type: 'string',
          description: 'An interest of the user',
        },
        description: 'What are you passionate about?'
      },
      skills: {
        type: 'array',
        items: {
          type: 'string',
          description: 'A skill of the user',
        },
        description: 'What are you good at?'
      },
      values: {
        type: 'array',
        items: {
          type: 'string',
          description: 'A value of the user',
        },
        description: 'What values are most important to you?'
      },
      recognition: {
        type: 'array',
        items: {
          type: 'string',
          description: 'A recognition of the user',
        },
        description: 'What can you be recognized for?'
      },
      career_recommendation: {
        type: 'string',
        description: 'Recommended career based on Ikigai interview'
      },
      ikigai_alignment: {
        type: 'string',
        description: 'Summary of how the recommended career aligns with your Ikigai'
      }
    },
    required: [
      'interests',
      'skills',
      'values',
      'recognition',
      'career_recommendation',
      'ikigai_alignment'
    ],
  },
}];

// these are old definitions and inclue the "worth" word we don't want
export const functionDefinitions1 = [
  {
    name: 'get_interests',
    description: "Get summary of user's interests",
    parameters: {
      type: 'object',
      properties: {
        interests: {
          type: 'array',
          items: {
            type: 'string',
            description: 'An interest of the user',
          },
          description: "List of user's interests",
        },
      },
      required: ['interests'],
    },
  },
  {
    name: 'get_values',
    description: "Get summary of user's values",
    parameters: {
      type: 'object',
      properties: {
        values: {
          type: 'array',
          items: {
            type: 'string',
            description: 'A value of the user',
          },
          description: "List of user's values",
        },
      },
      required: ['values'],
    },
  },
  {
    name: 'get_skills',
    description: "Get summary of user's skills",
    parameters: {
      type: 'object',
      properties: {
        skills: {
          type: 'array',
          items: {
            type: 'string',
            description: 'A skill of the user',
          },
          description: "List of user's skills",
        },
      },
      required: ['skills'],
    },
  },
  {
    name: 'get_worth',
    description: "Get summary of user's perceived worth",
    parameters: {
      type: 'object',
      properties: {
        worth: {
          type: 'array',
          items: {
            type: 'string',
            description: 'A perceived of the user',
          },
          description: "List of user's perceived worth",
        },
      },
      required: ['worth'],
    },
  },
  {
    name: 'generate_ikigai_fit_block_01',
    description: 'Return the generated Ikigai fit block text for the first career interest',
    parameters: {
      type: 'object',
      properties: {
        career_interest_1: {
          type: 'string',
          description: 'The first career interest of the user',
        },
        career_interest_1_desc: {
          type: 'string',
          // description: 'Why is this a good fit for the user as the first one?',
          description: 'Why is this a good fit for the user?',
        },
      },
      required: ['career_interest_1', 'career_interest_1_desc'],
    },
  },
  {
    name: 'generate_ikigai_fit_block_02',
    description: "Get user's the second career interest",
    parameters: {
      type: 'object',
      properties: {
        career_interest_2: {
          type: 'string',
          description: 'The second career interest of the user',
        },
        career_interest_2_desc: {
          type: 'string',
          // description: 'Why is this a good fit for the user as the second one?',
          description: 'Why is this a good fit for the user?',
        },
      },
      required: ['career_interest_2', 'career_interest_2_desc'],
    },
  },
];
